import React, { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Link, useNavigate } from 'react-router-dom';

const Contact = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [submitted, setSubmitted] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSend = () => {
        setSubmitted(true);
    };

    useEffect(() => {
        setSubmitted(false);
    }, [navigate]);

    return (
        <div className='w-full jana-background-contact text-200'>
            <div className='flex flex-column m-auto w-full p-3 pb-8 lg:w-7 text-shadow'>
                <div className='mb-3 mt-6'>
                    <div className='text-200'>
                        <span className='text-2xl font-bold pb-0 inline-block' id='services-anchor'>
                            Contact me.
                        </span><br />
                    </div>
                </div>
                <div className="contact-form w-full">
                    {!submitted &&
                    <form method='POST' name='contact'
                        data-netlify='true' action='/' >
                        <input type="hidden" name="form-name" value="contact" />
                        <div className="form-content">
                            <div className="p-field pb-3">
                                <label htmlFor="name">What's your name?*</label>
                                <InputText className='w-full mt-1' style={{backgroundColor:'rgba(0, 0, 0, 0.52)', color:'white', border:'none', borderBottom:'1px solid white'}} id="name" name="name" value={formData.name} onChange={handleInputChange} required />
                            </div>
                            <div className="p-field pb-3">
                                <label htmlFor="email">What's your email address?*</label>
                                <InputText className='w-full mt-1' style={{backgroundColor:'rgba(0, 0, 0, 0.52)', color:'white', border:'none', borderBottom:'1px solid white'}} id="email" name="email" value={formData.email} onChange={handleInputChange} required />
                            </div>
                            <div className="p-field pb-3">
                                <label htmlFor="phone">What's your phone number?</label>
                                <InputText className='w-full mt-1' style={{backgroundColor:'rgba(0, 0, 0, 0.52)', color:'white', border:'none', borderBottom:'1px solid white'}} id="phone" name="phone" value={formData.phone} onChange={handleInputChange} />
                            </div>
                            <div className="p-field pb-3">
                                <label htmlFor="message">What's your message?*</label>
                                <InputTextarea className='w-full mt-1' style={{backgroundColor:'rgba(0, 0, 0, 0.52)', color:'white', border:'none', borderBottom:'1px solid white'}} id="message" name="message" value={formData.message} onChange={handleInputChange} rows={3} autoResize required />
                            </div>
                            <div className="p-field pb-3">
                                <small>*Required fields</small>
                                <br />
                                <small>By submiting this form, you agree with our <Link to='/privacy' className='text-300'>privacy policy</Link> .</small>
                            </div>
                            <Button type='submit' style={{backgroundColor:'rgba(0, 0, 0, 0.69)'}} className='' label="Submit" /*onClick={handleSend}*/ />
                        </div>
                    </form>}
                    {submitted &&
                    <div className="confirmation-message">
                        <p>Thank you for your message!</p>
                        <p>We will get back to you shortly.</p>
                    </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default Contact;
